import { ETagType, renderStringToReact, useTranslation } from '@web_opxp/features';

interface INonTerminatableProps {
  show: boolean;
}

export default function NonTerminatable({ show }: Readonly<INonTerminatableProps>) {
  const { t } = useTranslation();

  if (!show) {
    return null;
  }

  const nonterminableMessage = renderStringToReact(
    t('manage:Manage.Subscription.Nonterminable'),
    ETagType.p,
    'subscription-nonterminable'
  );

  return (
    <div className="row" data-testid="nonterminable-warning">
      <div className="col">{nonterminableMessage}</div>
    </div>
  );
}
